module.exports = __webpack_public_path__ + "img/extension-commands-mac.4cf1aabf.svg";